module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"parent_reviews":"上一則評論","more_reviews":{"true":"展開 {0} 則評論","false":"收起 {0} 則評論"}}}')
  delete Component.options._Ctor
}
